import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import toast from '../../common/toast';
import { GetRoles } from '../../../services/Api/roles/useApiRoles';
import { CreateUser } from '../../../services/Api/users/useApiUser';
import {
    Button,
    Input,
    LoadingSpinner,
    Modal,
    RowContainer,
    SelectList,
    Typography,
} from '../../common';
import { useGetUser } from '../../../contexts/user';

const NewUserModal = ({ closeForm, defaultValues = {} }) => {
    const { appUserDetails } = useGetUser();
    const [isOptionsLoading, setIsOptionsLoading] = useState(true);
    const [roleOptions, setRoleOptions] = useState([]);
    const { push } = useHistory();

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({ defaultValues });

    useEffect(() => {
        setIsOptionsLoading(false);
        GetRoles()
            .then((response) => {
                setRoleOptions(
                    response.data.map((r) => ({
                        value: r.id,
                        label: r.name,
                        disabled: r.id < appUserDetails?.roleid,
                    }))
                );
                setIsOptionsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                toast.error();
            });
    }, [appUserDetails]);

    const onSubmit = (data) => {
        const postData = {
            email: data.email,
            roleid: data.roleid.value,
            firstname: data.firstname.replace("'", "''"),
            surname: data.surname.replace("'", "''"),
        };

        CreateUser(postData)
            .then((response) => {
                if (response && response?.status === 200) {
                    const user = response.data[0];
                    push(`/users/${user.email}`);
                    toast.success('User Created');
                } else {
                    toast.error();
                }
            })
            .catch((err) => {
                if (
                    err.response?.data?.response ===
                    'User with email address specified already exists.'
                ) {
                    toast.error('A user with that email address already exists.');
                } else {
                    toast.error();
                }
            });
    };

    return (
        <Modal title="Create User" closeModal={closeForm}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="pb-4">
                    <Input
                        error={errors.firstname}
                        message={errors.firstname ? 'First Name is required' : undefined}
                        label="First Name *"
                        {...register('firstname', { required: true })}
                    />
                </div>

                <div className="pb-4">
                    <Input
                        error={errors.surname}
                        message={errors.surname ? 'Surname is required' : undefined}
                        label="Surname *"
                        {...register('surname', { required: true })}
                    />
                </div>

                <div className="pb-4">
                    <Input
                        error={errors.email}
                        message={
                            errors.email
                                ? 'Email is required'
                                : errors.exist
                                ? 'Email is already in use'
                                : undefined
                        }
                        label="Email *"
                        type="email"
                        defaultValue={defaultValues?.email || ''}
                        disabled={(defaultValues?.lock || []).includes('email')}
                        {...register('email', { required: true })}
                    />
                </div>
                <div className="pb-4">
                    <Typography variant="body3" color="grey-normal" className="pb-1">
                        Role *
                    </Typography>
                    {isOptionsLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Controller
                            name="roleid"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <SelectList
                                    options={roleOptions}
                                    value={value}
                                    onChange={onChange}
                                    error={errors.roleid}
                                />
                            )}
                            rules={{ required: true }}
                        />
                    )}
                    {errors.roleid && (
                        <Typography variant="body3" color="error" className="pt-1">
                            Role is required
                        </Typography>
                    )}
                </div>
                <RowContainer spacing="medium" className="justify-center">
                    <Button type="button" onClick={() => closeForm && closeForm()}>
                        Cancel
                    </Button>
                    <Button type="submit">Create</Button>
                </RowContainer>
            </form>
        </Modal>
    );
};

export default NewUserModal;
